import { _ } from "../../../../core/polyglot/polyglot.js";
import { formatCurrency } from "../../../../core/helpers/currency-formatting-util.js";
import { getCSSVariable } from "../../../../core/helpers/css-util.js";
import { getZeroPositionRatio } from "../../../../core/helpers/chart-util.js";
import AbstractChartStrategy from "../../../../core/widgets/ChartWidget/AbstractChartStrategy.js";

/**
 * Implements a Strategy to render the graph on top of the Balance sheet report.
 */
export default class BalanceSheetChartStrategy extends AbstractChartStrategy {
	_makeDatasets({ values = [] }) {
		const data = values.map((keyFigureValue) => keyFigureValue.getValue());
		this._zeroPositionRatio = getZeroPositionRatio({ data });

		return [this._makeDataset(data)];
	}

	_makeDataset(data) {
		return {
			type: "line",
			label: _("Adjusted Equity"),
			data,
			pointStyle: "circle",
			borderWidth: 2,
			pointRadius: 4,
			pointBorderWidth: 2,
			pointHoverRadius: 6,
			pointBackgroundColor: ({ raw }) =>
				raw < 0 ? this._getNegativeColor() : "white",
			borderColor: ({ raw }) =>
				raw < 0 ? this._getNegativeColor() : this._getPositiveColor(),
		};
	}

	_getChartOptions({ context }) {
		return {
			...super._getChartOptions(),
			fill: {
				target: "origin",
				above: this._makePositiveGradient({ context }),
				below: this._makeNegativeGradient({ context }),
			},
			scales: {
				x: { offset: true, display: false },
				y: {
					grid: { drawBorder: false },
					ticks: {
						callback: (value) => formatCurrency(value),
						maxTicksLimit: 4,
						...this._getMirroredTicksOptions(),
					},
				},
			},
			plugins: {
				tooltip: { callbacks: { label: this._makeChartItemLabel } },
			},
		};
	}

	_getMirroredTicksOptions() {
		return {
			mirror: true,
			crossAlign: "far",
			padding: -3,
			showLabelBackdrop: true,
			backdropPadding: 20,
			backdropColor: "white",
		};
	}

	_makeChartItemLabel(context) {
		return `${context.dataset.label}: ${formatCurrency(context.raw)}`;
	}

	_getPositiveColor() {
		return getCSSVariable("--balance-sheet-positive");
	}

	_getPositiveGradientColor() {
		return this._getPositiveColor();
	}
}
